import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
declare var $: any;
@Component({
  selector: 'app-edit-animal-samples',
  templateUrl: './edit-animal-samples.component.html',
  styleUrls: ['./edit-animal-samples.component.css']
})
export class EditAnimalSamplesComponent implements OnInit {
  getsampleseditApi:any;
  putsampleseditApi:any;
  EditSamplesFormValue:any;
  addUrl:any;
  getlistApi:any;
  getDiseaseListData:any;
  loginresponse:any;
  cby_mby:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService:CommonService) { }

  async ngOnInit() {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.cby_mby=this.loginresponse.user_id;
    let SamplesId = sessionStorage.getItem('samplesId');
    this.getsampleseditApi= "/animal_management/sample/"+ SamplesId;
    this.putsampleseditApi= "/animal_management/sample/"+ SamplesId;
    (await this.commonService.getApi(this.getsampleseditApi)). subscribe(
    (res:any) => {
         var date=res.data.tnam_sam_date_of_sample_collected;
         var testdate = date.split('T');
        $("#SamplesDate").val(testdate[0])       
         $("#Samplescollected").val(res.data.tnam_sam_sample_collected)
         $("#Description").val(res.data.tnam_sam_description)
        })
  }
  async AnimalSamples(){
    var farmid=sessionStorage.getItem('farmid');
    var Animalid=sessionStorage.getItem('animalid');
    var speciesid=sessionStorage.getItem('speciesid');
    var breedid=sessionStorage.getItem('breedid');
    var ageid=sessionStorage.getItem('ageid');
    this.EditSamplesFormValue = {
      "species_id":speciesid,
      "breed_id":breedid,
      "farm_id":farmid,
      "animal_code":Animalid,
      "age_group":ageid,
      "sample_collected":$("#Samplescollected").val(),
      "date_of_sample_collected":$("#SamplesDate").val(),
      "description":$("#Description").val(),
      "cby":this.cby_mby,
      "mby":this.cby_mby,
      "status": 1,
      "is_active": 1
  };
    (await this.commonService.putApi(this.putsampleseditApi,this.EditSamplesFormValue)).subscribe(
      data => {
          alert("Data edited successfully");
      });
      setTimeout(
        () : void => {
       
     this.router.navigate([this.returnUrl,{ fragment: 'Disease' }]);

        },
        500
      );
//}
  }

  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
